import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-check_line",
  "use": "vab-icon-check_line-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-check_line\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.1281 3.64303C14.3884 3.90338 14.3884 4.32549 14.1281 4.58584L6.63272 12.0812C6.34633 12.3675 5.88201 12.3675 5.59562 12.0812L1.87153 8.35707C1.61118 8.09673 1.61118 7.6746 1.87153 7.41427C2.13188 7.15393 2.55399 7.15393 2.81434 7.41427L6.11417 10.7141L13.1853 3.64303C13.4456 3.38268 13.8677 3.38268 14.1281 3.64303Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol